import { CREATE_ORG_V2_API } from '../constants/AppConstants';

const createAccount = async (accountInput, is3Legged) => {
  const {
    contactInformation,
    billingInformation,
    industryId,
    businessSegmentId,
    shippingEmail,
    customerReferralId,
    clientId,
    stateId,
    countryId,
  } = accountInput;

  const requestBody = {
    name: contactInformation.company,
    contactInformation: {
      firstName: contactInformation.firstName,
      lastName: contactInformation.lastName,
      email: contactInformation.email,
      address: contactInformation.address,
    },
    billingInformation: {
      firstName: billingInformation.firstName,
      lastName: billingInformation.lastName,
      email: billingInformation.email,
      address: billingInformation.address,
    },
    industryId,
    businessSegmentId,
    shippingEmail,
    consent: true,
    configuredSSO: 'LegacyProvider',
    authState: clientId,
    customerReferralId,
    stateId,
    countryId,
  };

  try {
    const response = await fetch(`${CREATE_ORG_V2_API}?is3legged=${is3Legged}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });

    const json = await response.json();
    return { ok: response.ok, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: error.message } };
  }
};

export default createAccount;
